import { all, put, takeEvery } from 'redux-saga/effects';
import gql from 'graphql-tag';
import { client } from 'src/apollo';


function* handleCreateEstablishmentSubmit(action) {

    const CREATE_ESTABLISHMENT_MUTATION = gql`
        mutation ($data: CreatePortalEstablishmentInput!) {
            createPortalEstablishment(data: $data) {
                portalUser {
                    id
                }
            }
        }
    `;

    // const { operatorId } = yield select(state => state.session);
    // const variables = {
    //     data: {
    //         ...action.payload,
    //         operatorId
    //     }
    // };

    // const variables = action.payload;
    const variables = {
        title: 'Zapay Sede',
        latitude: '0.0',
        longitude: '0.0',
        observation: 'ABC',
        phone: '619821456',
        operator: {
            id: 1 // TODO Informar apenas o ID.
        }
    };
    
    try {
        const { data } = yield client.mutate({
            mutation: CREATE_ESTABLISHMENT_MUTATION,
            variables
        });
    
    } catch(error) {
    }
}

function* watchCreateEstablishmentSubmit() {
    yield takeEvery('CREATE_ESTABLISHMENT_SUBMIT', handleCreateEstablishmentSubmit);
}

export default function* usersManagementRoot() {
    yield all([
        watchCreateEstablishmentSubmit()
    ]);
}



// WEBPACK FOOTER //
// ./src/sagas/establishments-management.js